import _ from "lodash";
import { IContainer, IEntry, IEntrySelection, IFile, IFileRoot, isFolder } from "../model/fileModel";
import { ImSet } from "@/twapp/react/tromanImmutable";
import { IMoveFilesCmd } from "@/twapp/server/FileEndpoint";

export interface IPreparedMove {
    invalidTargetsIds: ImSet<string>;
    selection: IEntrySelection;
}

function getInvalidTargetIds(entries: IEntrySelection): ImSet<string> {
    const invalid = new Set<string>();
    const pending = [...entries.folders];
    while (pending.length > 0) {
        const current = pending.pop()!;
        invalid.add(current.id);
        pending.push(...current.folders);
    }
    return ImSet(invalid);
}

export function prepareFileMove(root: IFileRoot, entries: IEntrySelection): IPreparedMove {

    const invalid = getInvalidTargetIds(entries);

    return {
        invalidTargetsIds: invalid,
        selection: entries,
    }
}

export interface IMovableEntries {
    noconflict: IEntry[];
    needrename: { existing: IEntry, moving: IEntry }[];
}

export function getMovableEntries(target: IContainer, files: IPreparedMove): IMovableEntries | undefined {

    if (target === files.selection.container) {
        return;
    }

    if (isFolder(target) && files.invalidTargetsIds.has(target.id)) {
        return;
    }

    const result: IMovableEntries = {
        needrename: [],
        noconflict: [],
    };

    const existingEntries = new Map([...target.files, ...target.folders].map(x => [x.name.toLowerCase(), x]));
    for (let moving of [...files.selection.files, ...files.selection.folders]) {
        const existing = existingEntries.get(moving.name.toLowerCase());
        if (existing) {
            result.needrename.push({ existing, moving })
        } else {
            result.noconflict.push(moving);
        }
    }

    if (result.noconflict.length === 0 && result.needrename.length === 0) {
        return undefined;
    }
    
    return result;
}

export function createMoveCmd(root: IFileRoot, target: IContainer, movable: IMovableEntries, renameIfExists: boolean): IMoveFilesCmd {
    
    const targetId = isFolder(target) ? target.id : null;
    const tomove = movable.noconflict.map(x => x.id);

    if (renameIfExists) {
        for (let replacing of movable.needrename) {
            tomove.push(replacing.moving.id);
        }
    }

    return {
        TargetFolder: targetId,
        FileIds: tomove,
        OwnerId: root.ownerId,
        OwnerType: root.ownerType,
        RenameIfExists: renameIfExists,
    }
}